//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CreditCardBrand } from './Enums';

export class CreditCardRegisterInputItem extends ItemBase {  // OBSOLETE - Use only for compatibility
    AddressLine1: string | null = null;
    AddressLine2: string | null = null;
    City: string | null = null;
    CountryCode: string | null = null;
    ExpiryDate: string = "1970-01-01T00:00:00";
    CardholderName: string | null = null;
    CardNumber: string | null = null;
    PostalCode: string | null = null;
    ProvStateCode: string | null = null;
    Brand: CreditCardBrand = CreditCardBrand.Amex;
    CvcCode: string | null = null;
    PaymentSourceToken: string | null = null;

    constructor(initializer?: Partial<CreditCardRegisterInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CreditCardRegisterInputItem";
}
